/**
 * Compare KR duration dates (saved metric vs selected kr_duration).
 */
import moment from 'moment';

/** MM/DD/YYYY for comparison: unix seconds, date strings, or kr_duration values. */
function toDisplayMmDdYyyy(value) {
  if (value == null || value === '') {
    return '';
  }
  if (typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(String(value).trim()))) {
    const n = Number(value);
    if (!Number.isNaN(n)) {
      return moment.unix(n).utc().format('MM/DD/YYYY');
    }
  }
  const m = moment.utc(value);
  return m.isValid() ? m.format('MM/DD/YYYY') : String(value).trim();
}

/** Saved span: metric start_date / end_date; if either is empty, same side from goal (start_date / target_date). */
function savedMetricStartEndDisplay(item, goal) {
  if (!item) {
    return { start: '', end: '' };
  }
  let start = toDisplayMmDdYyyy(item.start_date);
  let end = toDisplayMmDdYyyy(item.end_date);
  if (goal) {
    if (start === '') {
      start = toDisplayMmDdYyyy(goal.start_date);
    }
    if (end === '') {
      end = toDisplayMmDdYyyy(goal.target_date);
    }
  }
  return { start, end };
}

function normalizeKrDurationStartEnd(krDuration) {
  if (!krDuration) {
    return { start: '', end: '' };
  }
  return {
    start: toDisplayMmDdYyyy(krDuration.start),
    end: toDisplayMmDdYyyy(krDuration.end),
  };
}

/**
 * True when selected start/end differs from saved (after normalizing to MM/DD/YYYY UTC).
 * @param {object} [goal] When item start_date or end_date is empty, that side uses goal.start_date or goal.target_date.
 */
export function isKrDurationChangedFromSaved(item, krDuration, goal) {
  if (!item || item.id == null || item.id === '') {
    return false;
  }
  if (!krDuration) {
    return false;
  }
  const saved = savedMetricStartEndDisplay(item, goal);
  const selected = normalizeKrDurationStartEnd(krDuration);
  return saved.start !== selected.start || saved.end !== selected.end;
}
